import React from 'react';
import { cn } from '../../lib/utils';

/**
 * LogoLockup - Brand logo component
 * Flexible display modes for different contexts:
 * - 'urgaa-only': Just URGAA text (for dashboards)
 * - 'logo-only': Just Go4Garage logo image  
 * - 'full': Both logo and URGAA text
 * - 'minimal': Just URGAA text, compact
 */

const LogoLockup = ({ 
  size = 'md',
  showTagline = false,
  mode = 'full', // 'urgaa-only' | 'logo-only' | 'full' | 'minimal'
  className = '',
}) => {
  const sizeClasses = {
    sm: 'h-7',
    md: 'h-9',
    lg: 'h-11',
    xl: 'h-14',
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
  };

  // Minimal mode - just URGAA text inline
  if (mode === 'minimal') {
    return (
      <span 
        className={cn(
          'font-extrabold tracking-tight',
          textSizes[size],
          className
        )}
        style={{ color: '#FF6B35', fontWeight: 800 }}
      >
        URGAA
      </span>
    );
  }

  // Logo only mode
  if (mode === 'logo-only') {
    return (
      <img 
        src="/assets/go4garage-logo-main.jpg" 
        alt="Go4Garage"
        className={cn(
          'object-contain',
          sizeClasses[size],
          className
        )}
      />
    );
  }

  // URGAA only mode - clean text with optional tagline
  if (mode === 'urgaa-only') {
    return (
      <div className={cn('flex flex-col', className)}>
        <span 
          className={cn(
            'font-extrabold tracking-tight',
            textSizes[size]
          )}
          style={{ color: '#FF6B35', fontWeight: 800 }}
        >
          URGAA
        </span>
        {showTagline && (
          <span className="text-[10px] text-gray-500 dark:text-gray-400 -mt-0.5 font-bold">
            Charging Tomorrow with Green Energy
          </span>
        )}
      </div>
    );
  }

  // Full mode - logo + text (default)
  return (
    <div className={cn('flex items-center gap-2', className)}>
      {/* Go4Garage Logo */}
      <img 
        src="/assets/go4garage-logo-main.jpg" 
        alt="Go4Garage"
        className={cn(
          'object-contain',
          sizeClasses[size]
        )}
      />
      
      {/* Text */}
      <div className="flex flex-col">
        <span 
          className={cn(
            'font-extrabold tracking-tight',
            textSizes[size]
          )}
          style={{ color: '#FF6B35', fontWeight: 800 }}
        >
          URGAA
        </span>
        {showTagline && (
          <span className="text-[10px] text-gray-500 dark:text-gray-400 -mt-0.5 font-bold">
            Charging Tomorrow with Green Energy
          </span>
        )}
      </div>
    </div>
  );
};

export default LogoLockup;